import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Scene } from "../interfaces/scene.interface";
import { displayConfig } from "../config/display.config";
import { displayByProvider } from "../redux/display-slice";
import { IDisplayState } from "../interfaces/display-state.interface";
import { SceneToken } from "../enums/scene-token.enum";

type Writeable<T> = { -readonly [P in keyof T]: T[P] };

export const useDisplay = (current: Scene, next?: Scene) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const displayState: Partial<Writeable<IDisplayState>> = {};
    const config = displayConfig();
    let prop: string;
    for (prop in config) {
      let currentSceneStatus = Boolean(config[prop]?.find(({ token }) => token == current?.token)?.active);
      let nextSceneStatus = Boolean(config[prop]?.find(({ token }) => token == next?.token)?.active);
      let value = currentSceneStatus;

      if (!current?.status) {
        if (!nextSceneStatus) value = false;
      } else {
        if (prop == "expert" && current?.token == SceneToken.QUESTION) continue;
      }

      displayState[prop] = value;
    }

    dispatch(displayByProvider(displayState));
  }, [current, next, dispatch]);
};